import React from 'react';
import classnames from 'classnames/bind';

import css from './shards.module.scss';

const styles = classnames.bind(css);

export const LeftShard = () => <div aria-hidden className={styles('left-shard')} />;

export const RightShard = () => <div aria-hidden className={styles('right-shard')} />;

export const LeftGreyShard = () => <div aria-hidden className={styles('left-grey-shard')} />;

export const RightGreyShard = () => <div aria-hidden className={styles('right-grey-shard')} />;
